// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"432":"f868105a","552":"e41659e2","817":"82ec8473","930":"046eac5c","959":"e75b6f4b","962":"498f65b4"}[chunkId] + ".chunk.js";
};